/* global getPosition */
(function () {
    'use strict';
    
    var firstItem;
    var incrementsArray;

    /* INIT */
    $(window).ready(function () {
        if (!$('.membership-statistics-com-ctn').length) {
            return;
        }
        firstItem = $('.membership-statistics-box-value')[0];

        $(window).on('scroll', checkPosition);
        checkPosition();
    });
    
    function checkPosition() {
        if (window.innerHeight + window.scrollY > getPosition(firstItem).y) {
            // Detected proximity, turn off position checking for performance purpose
            $(window).off('scroll', checkPosition);
            // Initiate the array
            incrementsArray = [];
            // Activate number changing on each item
            $('.membership-statistics-box-value').each(function(i, el) {
                // Span over 2 seconds at the interval of 42 miliseconds
                incrementsArray[i] = parseFloat(el.getAttribute('data-value')) / (2000 / 42);
                runValues(i, el);
            });
        }
    }
    
    function runValues(i, el) {
        var a = parseInt(el.getAttribute('data-value'));
        var b = parseFloat(el.getAttribute('data-current')) + incrementsArray[i];
        
        el.setAttribute('data-current', b);
        el.textContent = Math.round(b);
        if (a > b) {
            setTimeout(function() {
                runValues(i, el);
            }, 42);
        } else if (a != b) {
            el.textContent = a;
        }
    }

})();